import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-chip-cont',
  templateUrl: './chip-cont.component.html',
  styleUrls: ['./chip-cont.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ChipContComponent {

  @Input() isSlider = true;

  constructor() { }

  get gridOrSlider(): string {
    return this.isSlider ? 'slider' : 'grid';
  }

}
